import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000, // 1 min for most dashboard lists
      gcTime: 5 * 60 * 1000, // Keep cache for 5 min (smooth navigation)
      refetchOnWindowFocus: false, // Dashboards don't need this spam
      refetchOnReconnect: false,
      refetchOnMount: false,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});
